import { render, staticRenderFns } from "./GroupViewFilter.vue?vue&type=template&id=a2d1cdb0&"
import script from "./GroupViewFilter.vue?vue&type=script&lang=js&"
export * from "./GroupViewFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports